export default __webpack_public_path__ + "static/media/NOTO_SANS.9ab05beb.ttf";